export enum NotificationAction {
	Add = 0,
	Update = 1,
	Delete = 2
}
